import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import has from 'lodash/has';

export class Bootstrap {
    constructor(dataSource = document.getElementById('data-bootstrap'), attr = 'data-bootstrap') {
        if (typeof dataSource === 'function') {
            /* eslint-disable no-param-reassign */
            dataSource = dataSource();
            /* eslint-enable no-param-reassign */
        }

        this._data = {};
        if (dataSource instanceof HTMLElement) {
            try {
                this._data = JSON.parse(dataSource.getAttribute(attr));
                // Don't remove the data source while there
                // are multiple consumers of the bootstrap
                // dataSource.remove();
            } catch (e) {
                // Invalid JSON
            }
        } else if (typeof dataSource === 'string') {
            try {
                this._data = JSON.parse(dataSource);
            } catch (e) {
                // Invalid JSON
            }
        } else if (typeof dataSource === 'object') {
            this._data = cloneDeep(dataSource);
        } else {
            throw new Error('Unsupported bootstrap data type');
        }
    }

    set data(data) {
        throw new Error('Bootstrap data is read-only!');
    }

    get data() {
        return cloneDeep(this._data);
    }

    get(path, fallback) {
        const result = get(this._data, path, fallback);
        if (typeof result === 'object') {
            return cloneDeep(result);
        }
        return result;
    }

    getMultiple(...args) {
        const result = args.reduce((accum, key) => {
            // eslint-disable-next-line no-param-reassign
            accum[key] = this.get(key, '');
            return accum;
        }, {});
        return result;
    }

    has(path) {
        return has(this._data, path);
    }
}

let bootstrapInstance;

export function getInstance() {
    if (!bootstrapInstance) {
        bootstrapInstance = new Bootstrap();

        if (__DEVELOPMENT__) {
            window.bootstrap = bootstrapInstance;
        }
    }
    return bootstrapInstance;
}

// Can only destroy the instance in tests
export function destroyInstance() {
    if (__TESTING__) {
        bootstrapInstance = null;
    }
}
